import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Logo } from "../../../../../../../../models/company";
import ImageInput from "../../../../../../../../components/Form/ImageInput";
import { useProductContext } from "../../../../context/ProductContext";
import { ProductSectionTitle } from "../../../components/SectionTitle";

interface Props {
  isLoading?: boolean;
  view?: boolean;
}

const ProductPhoto = (props: Props) => {
  const { view, isLoading } = props;
  const { product, handleUpdateProduct } = useProductContext();
  const { t: translate } = useTranslation();

  return (
    <>
      <Grid container item xs={12} spacing={3}>
        <ProductSectionTitle>{translate("productPhoto")}</ProductSectionTitle>
        <Grid item xs={12}>
          <ImageInput
            id="product-photo"
            title={""}
            description={translate("uploadImage")}
            logo={product?.picture as Logo}
            onChangeLogo={(logo?: Logo) => {
              handleUpdateProduct("picture", logo);
            }}
            disabled={isLoading || view}
            showActionButtons
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ProductPhoto;
